import { ExodusResources } from './exodus.resource';

export const LabTestUrl = {
    LABTEST_GET: ExodusResources.LABTEST,
    LABTEST_ADD: ExodusResources.LABTEST,
    LABTEST_UPDATE: ExodusResources.LABTEST + '/',
    LABTEST_DELETE: ExodusResources.LABTEST + '/{id}',
    LABTEST_GET_CENTRE : ExodusResources.LABTEST + '/{0}/centrelabtest',
    LABTEST_GET_SCREENTYPE : ExodusResources.LABTEST + '/GetScreenType',
    LABTEST_GET_LABTESTTYPE : ExodusResources.LABTEST + '/GetLabtestType',
    LABTEST_GET_LABTEST_TESTRESULT : ExodusResources.LABTEST + '/GetLabtestTestResult',
    LABTEST_DETAIL : ExodusResources.LABTEST + '/'    ,
    LABTEST_GET_BY_NAME : ExodusResources.LABTEST + '/search-by-name'        
};


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/master-data.labtest.url.ts